import { ColoredCircle, FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { ASSET_TYPE_VEHICLE } from '../../constants/asset';
import { useStyles } from '../../hooks/useStyles';
import { AssetType } from '../../types/asset';
import { Vehicle } from '../../types/vehicle';
import { assetTypeDataTitle } from '../../utils/assets';

type Props = Readonly<{
  vehicle: Vehicle;
  assetType?: AssetType;
}>;

function AssetVehicleData({ vehicle, assetType = ASSET_TYPE_VEHICLE }: Props) {
  const { theme, classes, css } = useStyles();
  const labelWidth = '110px';

  return (
    <FlexColumn gap={theme.sizing.scale500}>
      <LabelSmall className={classes.dataHeaderClass}>{assetTypeDataTitle(assetType)}</LabelSmall>
      <FlexColumn
        gap={theme.sizing.scale300}
        classNames={classes.dataContentClass}
      >
        {vehicle.licensePlate && (
          <LabeledData
            label="Placa:"
            content={vehicle.licensePlate}
            labelWidth={labelWidth}
          />
        )}
        {vehicle.vehicleType && (
          <LabeledData
            label="Tipo:"
            content={vehicle.vehicleType.charAt(0).toUpperCase() + vehicle.vehicleType.slice(1)}
            labelWidth={labelWidth}
          />
        )}
        {vehicle.brand?.name && (
          <LabeledData
            label="Marca:"
            content={vehicle.brand?.name}
            labelWidth={labelWidth}
          />
        )}
        {vehicle.subBrand?.name && (
          <LabeledData
            label="Submarca:"
            content={vehicle.subBrand?.name}
            labelWidth={labelWidth}
          />
        )}
        {vehicle.version?.name && (
          <LabeledData
            label="Version:"
            content={vehicle.version?.name}
            labelWidth={labelWidth}
          />
        )}
        {!!vehicle.year && (
          <LabeledData
            label="Modelo:"
            content={vehicle.year?.toString()}
            labelWidth={labelWidth}
          />
        )}
        {vehicle.color && (
          <LabeledData
            label="Color:"
            verticalAlign="center"
            labelWidth={labelWidth}
            content={
              <ParagraphSmall
                color={theme.colors.contentSecondary}
                margin={0}
                className={`${classes.horizontalFlex} ${classes.centeredStart} ${css({
                  gap: theme.sizing.scale200,
                })}`}
              >
                {vehicle?.color ? <ColoredCircle color={vehicle.color} /> : '-'}
              </ParagraphSmall>
            }
          />
        )}
        {vehicle.vin && (
          <LabeledData
            label="No. Serie:"
            content={vehicle.vin}
            labelWidth={labelWidth}
          />
        )}
      </FlexColumn>
    </FlexColumn>
  );
}

export default memo(AssetVehicleData);
